/**
 * @generated SignedSource<<bf23d4f7b0291b155c061eb94db10fa2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueCommentEditor_repository$data = {
  readonly repository: {
    readonly databaseId: number | null;
    readonly nameWithOwner: string;
    readonly slashCommandsEnabled: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"deleteIssueCommentMutation_Comment" | "updateIssueCommentBodyMutation_Comment">;
  readonly " $fragmentType": "IssueCommentEditor_repository";
};
export type IssueCommentEditor_repository$key = {
  readonly " $data"?: IssueCommentEditor_repository$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueCommentEditor_repository">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueCommentEditor_repository",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slashCommandsEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameWithOwner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "databaseId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "updateIssueCommentBodyMutation_Comment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "deleteIssueCommentMutation_Comment"
    }
  ],
  "type": "IssueComment",
  "abstractKey": null
};

(node as any).hash = "f882a41d48f22444e3acc4c81c6db007";

export default node;
